import { RetrieveWorkLoadsFilter, WorkLoadsCalendar } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { formatDate } from "../utils/formatDate";

function getWorkLoads(httpClient: HttpClient) {
  return (filter: RetrieveWorkLoadsFilter) => {
    const view =
      filter.view === "monthly"
        ? "/week"
        : filter.view === "year"
          ? "/month"
          : "";

    return httpClient
      .sendHttpRequest<WorkLoadsCalendar>({
        endpoint: `${
          !!filter.resources
            ? "/resources/workloads"
            : "/resources/allworkloads"
        }${view}`,
        method: HttpMethods.POST,
        data: {
          ...(filter.resources && {
            resourceIds: filter.resources.map(({ uuid }) => uuid),
          }),
          startDate: formatDate(filter.startDate),
          endDate: formatDate(
            new Date(
              new Date(filter.endDate).getTime() + 1000 * 60 * 60 * 24,
            ).toISOString(),
          ),
        },
      })
      .then((workLoadsCalendar) =>
        workLoadsCalendar.map((cal) => ({
          ...cal,
          days: "days" in cal ? cal.days : [],
          weeks: "weeks" in cal ? cal.weeks : [],
          months: "months" in cal ? cal.months : [],
        })),
      );
  };
}

export { getWorkLoads };
